import { useSelector } from "react-redux"

const useProxyPath = () => useSelector(state => state.settings.proxyPath)

const useRecaptchaSiteKey = () => useSelector(state => state.settings.recaptchaSiteKey)

const useIsShowingNavbarSearch = () => useSelector(state => state.settings.isShowingNavbarSearch)

export { useProxyPath, useRecaptchaSiteKey, useIsShowingNavbarSearch }
